import type {TableConfiguration} from 'schema/table/types';
import type {WorkV4} from 'services/metadata/types';
import {defaultTableConfig} from 'schema/table/configuration/defaultTableConfig';
import {Counter} from '../../renderers/Counter';
import {Agents} from '../../renderers/table';
import {workDefaultColumns} from './columns';

export const workTableConfig: TableConfiguration<WorkV4> = {
  ...defaultTableConfig,
  defaultColumns: workDefaultColumns,
  partValueRenderers: {
    links: Counter,
    agents: Agents,
  },
};
